<div class="container-fluid">
    <div class="row">
        <div class="col-sm-6 login-section-wrapper">
            <div class="login-wrapper my-auto">
                <h1 class="heading fw-bold">{{ isForgotPasswordMode ? 'Forgot Password' : 'Log in' }}</h1>
                <form action="" [formGroup]="authForm" (ngSubmit)="isForgotPasswordMode ? forgetPassword() : login()">
                    <div class="form-group">
                        <label for="email">Email ID</label>
                        <input class="form-control" formControlName="email_id" placeholder="Enter Email">
                        <span class="text-danger small-text"
                            *ngIf="authForm.get('email_id')?.hasError('required') && authForm.get('email_id')?.touched">
                            Please Enter Your Email
                        </span>
                        <span class="text-danger small-text"
                            *ngIf="authForm.get('email_id')?.hasError('email') && authForm.get('email_id')?.touched">
                            Email is Not Valid
                        </span>
                    </div>
                    <!-- Password Field (only for login mode) -->
                    <div *ngIf="!isForgotPasswordMode" class="form-group mb-4">
                        <label>Password</label>
                        <input type="password" class="form-control" formControlName="password" placeholder="Enter Password">
                        <span class="text-danger small-text"
                        *ngIf="authForm.get('password')?.hasError('required') && authForm.get('password')?.touched">
                        Please enter Password
                        </span>

                        <!-- Toggle Link -->
                        <div class="text-end mt-1">
                        <a (click)="toggleMode()" class="text-primary" style="cursor: pointer;">Forgot password?</a>
                        </div>
                    </div>

                    <!-- Back to Login Link -->
                    <div *ngIf="isForgotPasswordMode" class="text-end mt-1">
                        <a (click)="toggleMode()" class="text-primary" style="cursor: pointer;">Back to Login</a>
                    </div>

                    <!-- Submit Button -->
                    <button class="yellow mt-6" type="submit">
                        {{ isForgotPasswordMode ? 'Send Reset Link' : 'Login' }}
                    </button>
                </form>
            </div>
        </div>
        <div class="col-sm-6 px-0 d-none d-sm-block">
            <img src="./assets/images/service.jpg" alt="login image" class="login-img">
        </div>
    </div>
</div>